import { useSelector } from 'react-redux';
import { getTab } from './selectors';

export const useTab = () => useSelector(getTab);
